export const MEMBER_TIER_THRESHOLDS = {
  CHAMPION_MIN: 15,
  POWER_MEMBER_MIN: 7,
  REGULAR_MEMBER_MIN: 2,
  REGULAR_MEMBER_MAX: 6,
  INACTIVE_THRESHOLD_DAYS: 30,
} as const;

export const TIER_LABELS = {
  INACTIVE: 'Inactive',
  REGULAR: 'Regular',
  POWER: 'Power',
  CHAMPION: 'Champion',
} as const;

export const TIER_DESCRIPTIONS = {
  INACTIVE: `No session in ${MEMBER_TIER_THRESHOLDS.INACTIVE_THRESHOLD_DAYS}+ days`,
  REGULAR: `${MEMBER_TIER_THRESHOLDS.REGULAR_MEMBER_MIN}–${MEMBER_TIER_THRESHOLDS.REGULAR_MEMBER_MAX} sessions/month`,
  POWER: `${MEMBER_TIER_THRESHOLDS.POWER_MEMBER_MIN}–${MEMBER_TIER_THRESHOLDS.CHAMPION_MIN - 1} sessions/month`,
  CHAMPION: `${MEMBER_TIER_THRESHOLDS.CHAMPION_MIN}+ sessions/month`,
} as const;
